<script>
import BuyTrial from './buy-trial.vue';
import baseFormMixin from '@/plans/ZOOM_SCHEDULER/mx/base';
import formMixin from '@/plans/ZOOM_SCHEDULER/mx/buy-now-trial';
import saveMixins from '../../ZOOM_MEETING/save-mixins';


export default {
  ...BuyTrial,
  mixins: [baseFormMixin, formMixin, saveMixins],
};
</script>
